module.exports = __webpack_public_path__ + "static/media/COS_LOGO_ROUND.cb40b8da.png";